const SvgLogoIconAlt = (props) => (
  <svg viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0L10.4934 10.4933C12.2863 8.70046 14.7612 7.58953 17.5 7.58953C22.9722 7.58953 27.4104 12.0278 27.4104 17.4999V27.4103L35 34.9998V0H0Z"
      fill="white"
    />
    <path
      d="M17.4998 7.59144C14.7664 7.59144 12.2861 8.70237 10.4932 10.4953L27.4047 27.4067V17.4963C27.4047 12.0242 22.9665 7.58594 17.4943 7.58594L17.4998 7.59144Z"
      fill="#363636"
    />
    <path d="M27.4107 27.4104H7.58984L17.5003 17.5L27.4107 27.4104Z" fill="#D3DDFF" />
    <path d="M35 34.9997H0L7.58957 27.4102H27.4104L35 34.9997Z" fill="#3763FF" />
    <path
      d="M10.4934 10.4933L0 0V34.9998L7.58957 27.4103V17.4999C7.58957 14.7666 8.7005 12.2862 10.4934 10.4933Z"
      fill="#3763FF"
    />
    <path
      d="M10.4937 10.4922C8.70078 12.2851 7.58984 14.7599 7.58984 17.4988V27.4091L17.5003 17.4988L10.4937 10.4922Z"
      fill="white"
    />
  </svg>
);

export default SvgLogoIconAlt;
